import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context';
import { ROUTES, ROLES } from '../../constants';
import './Navigation.css';

export function Navigation() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path: string) => location.pathname === path;
  const isAdmin = user?.role === ROLES.ADMIN;

  const handleLogout = async () => {
    await logout();
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link to={ROUTES.HOME} className="nav-logo" onClick={closeMenu}>
          <img src="/logo.jpg" alt="Green Production" className="nav-logo-img" />
        </Link>

        <button className="nav-hamburger" onClick={toggleMenu} aria-label="Toggle menu">
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
        </button>

        <div className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
          <Link
            to={ROUTES.SCHEDULE}
            className={`nav-link ${isActive(ROUTES.SCHEDULE) ? 'active' : ''}`}
            onClick={closeMenu}
          >
            PRODUCTION
          </Link>
          <Link
            to={ROUTES.EQUIPMENT}
            className={`nav-link ${isActive(ROUTES.EQUIPMENT) ? 'active' : ''}`}
            onClick={closeMenu}
          >
            EQUIPMENT
          </Link>
          <Link
            to={ROUTES.PRODUCTS}
            className={`nav-link ${isActive(ROUTES.PRODUCTS) ? 'active' : ''}`}
            onClick={closeMenu}
          >
            PRODUCTS
          </Link>
          <Link
            to={ROUTES.METRICS}
            className={`nav-link ${isActive(ROUTES.METRICS) ? 'active' : ''}`}
            onClick={closeMenu}
          >
            METRICS
          </Link>
          {isAdmin && (
            <Link
              to={ROUTES.ADMIN_USERS}
              className={`nav-link ${isActive(ROUTES.ADMIN_USERS) ? 'active' : ''}`}
              onClick={closeMenu}
            >
              USERS
            </Link>
          )}
          {/* CONFIG nav hidden for now — page not ready; route also disabled in App.tsx */}
          {isAdmin && (
            <Link
              to={ROUTES.ADMIN_STAFF_SCHEDULE}
              className={`nav-link ${isActive(ROUTES.ADMIN_STAFF_SCHEDULE) ? 'active' : ''}`}
              onClick={closeMenu}
            >
              SCHEDULE
            </Link>
          )}
        </div>

        <div className="nav-user-section">
          <div className="nav-user">
            <span className="nav-user-name">{user?.name}</span>
            <span className="nav-user-role">{user?.role}</span>
          </div>

          <button className="nav-logout" onClick={handleLogout}>
            LOGOUT
          </button>
        </div>
      </div>
    </nav>
  );
}
